<template>
    <figure
        class="origin-top-center relative flex scale-[0.88] transform lg:scale-100"
        id="floor-selection"
    >
        <div
            class="creative absolute right-[164px] flex h-[480px] w-[240px] lg:relative lg:right-auto"
        >
            <img
                src="assets/images/floor-min.webp"
                alt="Klet"
                id="imgKlet"
                class="floor pointer-events-none absolute left-0 top-0 h-[480px] w-[240px] select-none opacity-0"
            />
            <img
                src="assets/images/floor-0.webp"
                alt="Pritličje"
                id="imgPritlicje"
                class="floor pointer-events-none absolute left-0 top-0 h-[480px] w-[240px] select-none opacity-100"
            />
            <img
                src="assets/images/floor-floor.webp"
                alt="Nadstropje"
                id="imgNadstropje"
                class="floor pointer-events-none absolute left-0 top-0 h-[480px] w-[240px] select-none opacity-0"
            />
            <img
                src="assets/images/floor-max.webp"
                alt="Podstrešje"
                id="imgPodstresje"
                class="floor pointer-events-none absolute left-0 top-0 h-[480px] w-[240px] select-none opacity-0"
            />
        </div>
        <div
            class="legend absolute right-0 mr-[-70px] flex h-[480px] w-full min-w-[1px] max-w-[240px] flex-1 gap-4 lg:relative lg:mr-auto"
        >
            <div class="floor-legend group">
                <input
                    id="floor"
                    type="range"
                    min="-1"
                    max="2"
                    value="0"
                    step="1"
                    class="cursor-pointer appearance-none"
                />
                <span class="relative mt-4 block w-[420px]">
                    <div
                        id="pingKlet"
                        class="ping absolute left-[30px] flex h-4 origin-top-left rotate-90 cursor-pointer gap-2"
                    >
                        <v-icon
                            icon="basement"
                            size="4"
                            class="text-black-40"
                        ></v-icon>
                        <div class="text-body-medium text-black-40">Klet</div>
                    </div>
                    <div
                        id="pingPritlicje"
                        class="ping absolute left-[153px] flex h-4 origin-top-left rotate-90 cursor-pointer gap-2"
                    >
                        <v-icon
                            icon="door"
                            size="4"
                            class="text-black-40"
                        ></v-icon>
                        <div class="text-body-medium text-black-40">
                            Pritličje
                        </div>
                    </div>
                    <div
                        id="pingNadstropje"
                        class="ping absolute left-[282px] flex h-4 origin-top-left rotate-90 cursor-pointer flex-col gap-2"
                    >
                        <div class="flex gap-2">
                            <v-icon
                                icon="stairs"
                                size="4"
                                class="text-black-40"
                            ></v-icon>
                            <div class="text-body-medium text-black-40">
                                Nadstropje
                            </div>
                        </div>
                        <div class="floor-number-form hidden">
                            <div
                                class="input group relative flex flex-col gap-[10px]"
                            >
                                <input
                                    id="floorNumber"
                                    type="number"
                                    value=""
                                    name="floorNumber"
                                    placeholder="Število"
                                />
                                <small
                                    class="hidden text-small-text-regular text-salmon"
                                    >Prosimo vnesite v katerem nadstropju se
                                    nahaja stanovanje</small
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        id="pingPodstresje"
                        class="ping absolute left-[406px] flex h-4 origin-top-left rotate-90 cursor-pointer gap-2"
                    >
                        <v-icon
                            icon="roofing"
                            size="4"
                            class="text-black-40"
                        ></v-icon>
                        <div class="text-body-medium text-black-40">
                            Podstrešje
                        </div>
                    </div>
                </span>
            </div>
        </div>
    </figure>
</template>

<script>
export default {
    mounted() {
        const floorInput = document.getElementById("floor");
        const imgKlet = document.getElementById("imgKlet");
        const imgPritlicje = document.getElementById("imgPritlicje");
        const imgNadstropje = document.getElementById("imgNadstropje");
        const imgPodstresje = document.getElementById("imgPodstresje");
        const imgFloor = document.getElementsByClassName("floor");

        const pingKlet = document.getElementById("pingKlet");
        const pingPritlicje = document.getElementById("pingPritlicje");
        const pingNadstropje = document.getElementById("pingNadstropje");
        const pingPodstresje = document.getElementById("pingPodstresje");

        const resetImagesOpacity = () => {
            for (let img of imgFloor) {
                img.classList.remove("opacity-100");
                img.classList.add("opacity-0");
            }
        };

        const resetActivePing = () => {
            pingKlet.classList.remove("active");
            pingPritlicje.classList.remove("active");
            pingNadstropje.classList.remove("active");
            pingPodstresje.classList.remove("active");
        };

        const handleFloorChange = () => {
            resetImagesOpacity();
            resetActivePing();
            const floorValue = floorInput.value;

            if (floorValue === "-1") {
                imgKlet.classList.add("opacity-100");
                pingKlet.classList.add("active");
            } else if (floorValue === "0") {
                imgPritlicje.classList.add("opacity-100");
                pingPritlicje.classList.add("active");
            } else if (floorValue === "1") {
                imgNadstropje.classList.add("opacity-100");
                pingNadstropje.classList.add("active");
            } else if (floorValue === "2") {
                imgPodstresje.classList.add("opacity-100");
                pingPodstresje.classList.add("active");
            } else {
                imgPritlicje.classList.add("opacity-100");
                pingPritlicje.classList.add("active");
            }
        };

        floorInput.addEventListener("input", handleFloorChange);
        handleFloorChange();

        // Event listeners for click events
        pingKlet.addEventListener("click", () => {
            floorInput.value = "-1";
            handleFloorChange();
        });

        pingPritlicje.addEventListener("click", () => {
            floorInput.value = "0";
            handleFloorChange();
        });

        pingNadstropje.addEventListener("click", () => {
            floorInput.value = "1";
            handleFloorChange();
        });

        pingPodstresje.addEventListener("click", () => {
            floorInput.value = "2";
            handleFloorChange();
        });
    },
};
</script>
